import Syncable from '@/syncing/Syncable.js'
import { useInstanceStore } from '@/store/backendInstances.js'
import { isInstanceNotStalePrecondition, isLoggedInPrecondition, isOnlinePrecondition } from '@/syncing/SyncablePreconditions.js'

export default class OwnPermissionsSyncable extends Syncable {
  constructor(globalUniqueIdentifier) {
    super(globalUniqueIdentifier, 1000 * 60 * 30, [isOnlinePrecondition, isLoggedInPrecondition, isInstanceNotStalePrecondition])
  }

  hasInitialData() {
    return useInstanceStore().instances[this.globalUniqueIdentifier] && useInstanceStore().instances[this.globalUniqueIdentifier].availablePermissions
  }

  async workload() {
    await useInstanceStore().fetchOwnPermissions(this.globalUniqueIdentifier)
  }

  static getSyncableHandle() {
    return 'own-permissions'
  }
}
